const config = {
    API_URL: process.env.REACT_APP_API_URL,
    APP_TITLE: process.env.REACT_APP_TITLE,
};

export default config;
